export default __webpack_public_path__ + "static/media/dot_reported-selected.5e5f3538.svg";